/// <reference types="jquery" />

String.prototype.format = function (): string {
    'use strict';
    let str = this.toString();
    if (arguments.length) {
        let t = typeof arguments[0];
        let key: string;
        let args = ('string' === t || 'number' === t) ?
            Array.prototype.slice.call(arguments)
            : arguments[0];

        for (key in args) {
            str = str.replace(new RegExp('\\{' + key + '\\}', 'gi'), args[key]);
        }
    }

    return str;
};

String.prototype.basename = function (): string {
    'use strict';
    return this.toString().replace(/\\/g, '/').replace(/.*\//, '');
};

String.prototype.toNumber = function (): number {
    'use strict';
    return Number(this.toString());
};

Number.prototype.zeroPad = function(size = 2) {
    'use strict';
    let s = String(this);
    while (s.length < (size || 2)) {s = '0' + s;}
    return s;
};

(function ($) {
    if (!$) {
        return;
    }

    let affixFooter = () => {
        // jQuery is stupid
        const footer = $('body > footer');

        if (footer.length > 0) {
            footer.removeClass('affixed');
            if (footer.offset().top + footer.height() < $(window).height())
                footer.addClass('affixed');
        }
    };
    affixFooter();
    $(window).on('load resize scroll', affixFooter);
    setInterval(affixFooter, 2000);

    /** Watching for the root element's style attribute change for the Sanoma's cookie consent */
    (new MutationObserver(function (mutationList: MutationRecord[]) {
        mutationList.forEach(function (mutation: MutationRecord) {
            const navbar = document.querySelector<HTMLElement>('header.headroom');
            if (navbar) {
                navbar.style.marginTop = (<HTMLElement>mutation.target).style.marginTop;
            }
        });
    })).observe(document.querySelector<HTMLElement>('html'), {
        attributes: true,
        attributeFilter: ['style']
    });

    let queryParameters: JQuery.PlainObject = {},
        queryString = location.search.substring(1),
        re = /([^&=]+)=([^&]*)/g, m;
    while (m = re.exec(queryString)) {
        queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }

    /** Choice groups component **/
    let choiceGroupToggle = (e: JQuery.Event<HTMLElement, {}> | number, el?: Element) => {
        let name = $((typeof e == 'number' ? el : e.target)).attr('name');
        $('input[name="' + name + '"]').not(':checked').parent('label').removeClass('active');
        $('input[name="' + name + '"]:checked').parent('label').addClass('active');
    };
    let choiceGroupResize = () => {
        $('.choice-group').each((index, el) => {
            $(el).find('li>label').height('auto');
            let maxHeight = Math.max.apply(null, $(el).find('li>label').map(function () {
                return $(this).height();
            }).get());
            $(el).find('li>label').height((maxHeight < 22 ? 22 : maxHeight));
        });
    };
    $('.choice-group input[type=radio], .choice-group input[type=checkbox]').on('change', choiceGroupToggle).each(choiceGroupToggle);
    choiceGroupResize();
    $(window).resize(choiceGroupResize);

    /** Form dependencies **/
    let updateDependencies = (useAnimation = true, initial = true) => $('[data-routing-dependency]').each((index, el) => {
        let condition = $(el).data('routing-condition');
        let dependencies = $(el).data('routing-dependency');
        let invert = $(el).data('routing-invert') ? true : false;
        let parentVisible = $(el).is(':visible');
        if (typeof dependencies == 'string')
            dependencies = [dependencies];
        if (dependencies.length > 0) {
            let isVisible = null;
            for (let dep of dependencies) {
                dep = (<string>dep).split(':');
                let selectedValue = $('select[name^=' + dep[0] + ']').val();
                let checkedOrSelected = $('[name^=' + dep[0] + ']').filter('[value=' + dep[1] + ']').prop('checked')
                    ||
                    $('[name^=' + dep[0] + ']').filter('[type=checkbox]').filter('[value=1]').prop('checked') // Yes/No checkbox
                    ||
                    selectedValue == dep[1].toString()
                    ||
                    (selectedValue instanceof Array && selectedValue.indexOf(dep[1].toString()) > 0);
                if (checkedOrSelected) {
                    if (condition == 'or') {
                        isVisible = true;
                        break;
                    }
                    else {
                        isVisible = isVisible == null ? true : isVisible;
                    }
                }
                else {
                    isVisible = $(el).data('routing-satisfied') == true;
                    
                    if (invert)
                        isVisible = !isVisible;
                }
            }
            if (invert)
                isVisible = !isVisible;

            if (isVisible) {
                if (useAnimation)
                    $(el).is('li') ? $(el).fadeIn() : $(el).slideDown();
                else
                    $(el).show();

                if (!parentVisible)
                    $(el).find('input').each((index, item) => {
                        if ($(item).data('state') == true)
                            $(item).prop('checked', true);
                    });
            }
            else {
                if (useAnimation)
                    $(el).is('li') ? $(el).fadeOut() : $(el).slideUp();
                else
                    $(el).hide();
                try {
                    $(el).find('input:checked').data('state', true).prop('checked', false).parent('label').removeClass('active');
                }
                catch (e) {

                }
            }
        }
    }).promise().done(() => $('[data-routing-dependency]').trigger('routing-visibility-updated'));
    updateDependencies(false, true);
    $('input[type=checkbox], input[type=radio], select').on('change', () => updateDependencies(false, false));

    /** Zipcode/address validation **/
    $('input[name=zip_code], input[name=housenumber]').on('change', (): void => {
        let zipcode = $('input[name=zip_code]').val().toString().replace(' ', '');
        let number = parseInt($('input[name=housenumber]').val().toString());

        if (number == 0)
            return;

        jQuery.getJSON('/account/zipcode/' + zipcode + '/' + number, function (data: ZipCodeResponse) {
            if (data && data.city) {
                let $field = $('input[name=city]');
                $field.val(data.city);
                $field.trigger('blur');
            }
            if (data && data.street) {
                let $field = $('input[name=street]');
                $field.val(data.street);
                $field.trigger('blur');
            }
        });
    });

    $('.navbar .search-form').on('submit', function() {
        let query = $(this).find('[name=q]').val().toString().trim();

        if (query.length == 0)
            return false;
    });

    /** Fallback for avatars **/
    $('.article > .comments ul li > figure img').on('error', (e: JQuery.Event<HTMLElement, {}>): any => $(e.target).attr('src', $(e.target).data('fallback')));

    /** Scroll to top button **/
    $('a[href="#top"]').click((): boolean => {
        $('html, body').animate({scrollTop: 0}, 'slow');
        return false;
    });

    /** Reply to a comment button **/
    $('.article > .comments .buttons .btn-reply').on('click', (e: JQuery.Event<HTMLElement, {}>): boolean => {
        let removeForm = () => $('.article > .comments .comment-list .comment-form').remove();
        removeForm();

        let button = $(e.target);
        let form = $('.article > .comments > .comment-form').clone();
        form.find('[name=reply-to]').val(button.data('reply_id'));
        form.find('[type=reset]').on('click', removeForm);
        button.parent().after(form);
        return false;
    });

    jQuery.initSocialLogin = (options: LoginConfiguration) => {
        let tryVerifyTerms = (el: JQuery) => {
            let registerFormContainer = $(el).parents('.register-form-container');
            if (registerFormContainer.length > 0 && registerFormContainer.find('[name=terms]').prop('checked') != true) {
                alert('Om mee te kunnen doen aan Het Testpanel dien je akkoord te gaan met onze voorwaarden');
                return false;
            }
            return true;
        };

        let getScenario = () => {
            let scenario = $('.login-form-container [name=scenario]:checked').val();
            if (scenario == null || ['login', 'register'].indexOf(scenario.toString()) < 0)
                return 'login';
            return scenario;
        };

        let getRedirect = () => {
            let redirect = $('.login-form-container [name=redirect]').val();

            return redirect != null && redirect.toString().length > 0 ? redirect.toString() : '/';
        };

        $('.login-form-container').find('input[name=scenario]').on('change', function () {
            let button = $('.login-form-container').find('[type=submit]');
            let buttonFacebook = $('.login-form-container').find('.social-login.facebook');
            let buttonScoupy = $('.login-form-container').find('.social-login.scoupy');
            $('.scenario-block').removeClass('hidden');
            if ($(this).val() == 'register') {
                $('.scenario-block.login').slideUp({
                    queue: false
                });
                $('.scenario-block.register').slideDown({
                    queue: false
                });
                button.html('Registreren bij hettestpanel.nl');
                buttonFacebook.html('Registreren met je Facebook account');
                buttonScoupy.html('Registreren met je Scoupy account');
            }
            else {
                $('.scenario-block.register').slideUp({
                    queue: false
                });
                $('.scenario-block.login').slideDown({
                    queue: false
                });
                button.html('Inloggen bij hettestpanel.nl');
                buttonFacebook.html('Inloggen met je Facebook account');
                buttonScoupy.html('Inloggen met Scoupy account');
            }
        });

        window.fbAsyncInit = function () {
            FB.init({
                appId: options.facebook_app_id,
                xfbml: false,
                cookie: true,
                version: 'v2.7'
            });

            $('.social-login.facebook').on('click', function () {
                if (tryVerifyTerms($(this)) == false)
                    return false;

                if ($(this).hasClass('connected')) {
                    queryParameters['disconnect'] = 'facebook';
                    location.href = '?' + $.param(queryParameters);
                }
                else {
                    FB.login(function (response) {
                        if (response.status == 'connected') {
                            // user is loggedin
                            queryParameters['token'] = response.authResponse.accessToken;
                            queryParameters['service'] = 'facebook';
                            queryParameters['scenario'] = getScenario();
                            queryParameters['redirect'] = getRedirect();
                            location.href = '?' + $.param(queryParameters);
                        } else if (response.status == 'not_authorized') {
                            // user is loggedin on facebook, but not our app
                            // user did not login on facebook.
                        }
                    }, {scope: 'public_profile,email'});
                }
                return false;
            });
        };
        (function (d, s, id) {
            let js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = <HTMLScriptElement>d.createElement(s);
            js.id = id;
            js.src = '//connect.facebook.net/nl_NL/sdk.js';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        /** Scoupy login button **/
        window.ScoupyLoginAsyncInit = function () {
            let cb = (data: any) => {
                queryParameters['token'] = data['accessToken'];
                queryParameters['service'] = 'scoupy';
                queryParameters['scenario'] = getScenario();
                queryParameters['redirect'] = getRedirect();
                location.href = '?' + $.param(queryParameters);
            };

            ScoupyLogin.addListener('login', cb);

            $('.social-login.scoupy').on('click', function () {
                if (tryVerifyTerms($(this)) == false)
                    return false;

                if ($(this).hasClass('connected')) {
                    queryParameters['disconnect'] = 'scoupy';
                    location.href = '?' + $.param(queryParameters);
                }
                else {
                    ScoupyLogin.login();
                }
                return false;
            });
        }
    };
}(jQuery));